import { Injectable } from '@angular/core';
import { captureException, setUser } from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  public logError(error: any, context?: string): void {
    captureException(error, {
      tags: {
        origin: context || 'manual-capture',
      },
    });
  }

  public setUserContext(username: string | undefined): void {
    setUser({
      username,
    });
  }

  public clearUserContext(): void {
    setUser(null);
  }
}
